import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g id=\"mailConfirm.small\"><g id=\"envelope\"><path id=\"Vector\" d=\"M17.5 6.54166V4.5C17.5 4.10217 17.342 3.72064 17.0607 3.43934C16.7794 3.15804 16.3978 3 16 3H4C3.60218 3 3.22064 3.15804 2.93934 3.43934C2.65804 3.72064 2.5 4.10217 2.5 4.5V13.5C2.5 14.325 3.175 15 4 15H7.375\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path id=\"Vector_2\" d=\"M17.5 5.53888L10.7725 9.81388C10.541 9.95895 10.2732 10.0359 10 10.0359C9.72676 10.0359 9.45905 9.95895 9.2275 9.81388L2.5 5.53888\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></g><path id=\"Vector_3\" d=\"M11.5 15L13.8333 17L17.5 12\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }